export default __webpack_public_path__ + "static/media/EscudoPNG.35403e66.png";